import { render, staticRenderFns } from "./StudentEducationInfoPopover.vue?vue&type=template&id=694b17cb"
import script from "./StudentEducationInfoPopover.vue?vue&type=script&lang=ts"
export * from "./StudentEducationInfoPopover.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports